import { createContext, useContext } from "react";
import type { AuthFitnessCenterDO, AuthStaffDO, LoginResponseDO } from "@/types/auth";

export interface AuthContextValue {
  user: AuthStaffDO | null;
  activeGym: AuthFitnessCenterDO | null;
  gyms: AuthFitnessCenterDO[];
  rootGymId: string | null;
  canSwitchBranch: boolean;
  selectedBranchId: string;
  selectedBranch: AuthFitnessCenterDO | null;
  isAuthenticated: boolean;
  isAuthReady: boolean;
  isSwitchingBranch: boolean;
  isAdminView: boolean;
  setSelectedBranchId: (branchId: string) => void;
  setAuthSession: (response: LoginResponseDO) => void;
  clearAuthState: () => void;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be used within AuthProvider");
  }

  return context;
};
